import { action } from './index'
import { MESSAGE_SET_MESSAGE, MESSAGE_HIDE_MESSAGE } from './constants'
import { IMessage } from '../reducers/message'

export interface IShowMessageAction {
  readonly message: string
  readonly type?: IMessage['type']
}

export const showMessage = (payload: IShowMessageAction) => {
  return action(MESSAGE_SET_MESSAGE, payload)
}

export const hideMessage = () => {
  return action(MESSAGE_HIDE_MESSAGE)
}

export type MessageActions = ReturnType<typeof showMessage | typeof hideMessage>
